export const apiUrl = process.env.REACT_APP_API_URL;
export const captchaSiteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY || '';
export const analyticsJson = process.env.REACT_APP_GOOGLE_FIREBASE_ANALYTICS;
export const analyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_PROPERTY_ID;
export const enableDevFeatures = process.env.REACT_APP_ENABLE_DEV_ELEMENTS === 'true';
export const enableADs = process.env.REACT_APP_ENABLE_ADS === 'true';
export const isDevelopmentServer = process.env.NODE_ENV === 'development';
export const isProductionServer = process.env.NODE_ENV === 'production';
// The website (browser only, never the native mobile app) is shut down: no api requests are
// made, all routes are blocked, and sign in is replaced with an app-download notice.
// On by default; set REACT_APP_WEBSITE_SHUTDOWN=false to turn it off.
export const isWebsiteShutdown = process.env.REACT_APP_WEBSITE_SHUTDOWN !== 'false';
